import {
    Typography,
    Grid,
    Button,
    Box,
    TextField,
    Fade,
    IconButton,
    InputAdornment,
    CircularProgress,
    alpha,
    Alert,
    Snackbar,
    createTheme,
  } from "@mui/material";
  import { useEffect, useState } from "react";
  import { useDispatch } from "react-redux";
  import { useNavigate } from "react-router-dom";
  import {
    Visibility,
    VisibilityOff,
    Login as LoginIcon,
  } from "@mui/icons-material";
//import CreateAccountModel from "../../models/CreateAccountModel";
import axios from "axios";
  
  const CastcoLoginPage = () => {
    //const theme = useTheme();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    //const [errorPassword, setErrorPassword] = useState<string | null>(null);
    //const [errorhelperText, setErrorHelperText] = useState<string | null>(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
  

    //const [CreateAccountData, setCreateAccount] = useState(new CreateAccountModel())
    //const [showPasswordCreate, setShowPasswordCreate] = useState(false);
    //const [showPasswordDoubleCreate, setShowPasswordDoubleCreate] = useState(false);
    //const [isLoadingCreate, setIsLoadingCreate] = useState(false);
    //const [confirmPassword, setConfirmPassword] = useState<string | null>(null);

    const [isHovered, setIsHovered] = useState(false);

    const EnterKeyOnClick = (event: React.KeyboardEvent) => {
      if (event.key === "Enter") {
        handleLoginOnclick();
      }
    };
    

    const theme = createTheme({
        palette: {
            primary: {
                main: '#2e7d32',
              },
        },
      });

    useEffect(() => {
      const checkRefreshToken = async () => {
        try {
          const rt = localStorage.getItem("refreshToken");
          if (rt) {
            setIsLoading(true);
          }
        } catch (ex) {
          console.error(ex);
        } finally {
          setIsLoading(false);
        }
      };
  
      checkRefreshToken();
    }, [dispatch, navigate]);
  
    const handleLoginOnclick = async () => {
    //   if (!email || !password) {
    //     setError("Please enter both email and password");
    //     return;
    //   }
  
      try {
        setIsLoading(true);
        setError(null);
  
        axios.post(``, {email: email, password: password}).then((response)=>{
            if (response.status !== 200){
                setError("Login failed. Please check your credentials.");
            }else{
                navigate("/form");
            }
        }).catch(()=>{
            setError("Login failed. Please check your credentials.");
        })
      } catch (ex: any) {
        setError(
          ex.data?.message || "Login failed. Please check your credentials."
        );
      } finally {
        setIsLoading(false);
      }
    };

    return (
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          position: "fixed",
          top: 0,
          left: 0,
          background: theme.palette.background.default,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        <Grid
          container
          spacing={0}
          direction={{ xs: "column", md: "column", lg: "row" }}
          sx={{
            maxWidth: { xs: "100%", sm: "450px", md: "600px", lg: "1200px" },
            width: "100%",
            margin: "0 auto",
            borderRadius: { xs: 0, lg: 0 },
            overflow: "hidden",
            backgroundColor: theme.palette.background.paper,
            minHeight: { xs: "100vh", lg: "100%" },
          }}
        >
          {/* Title Section */}
          <Grid
            item
            xs={12}
            lg={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.light} 100%)`,
              color: theme.palette.primary.contrastText,
              padding: { xs: 3, sm: 4, md: 5, lg: 6 },
              minHeight: { xs: "auto", lg: "auto" },
              position: "relative",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background:
                  "radial-gradient(circle at 50% 50%, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 70%)",
                animation: "pulse 4s ease-in-out infinite",
                "@keyframes pulse": {
                  "0%": { transform: "scale(1)" },
                  "50%": { transform: "scale(1.2)" },
                  "100%": { transform: "scale(1)" },
                },
              },
            }}
          >
            <Fade in={true} timeout={1000}>
              <Box sx={{ position: "relative", zIndex: 1 }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontSize: { xs: "1.5rem", sm: "2rem" },
                    fontWeight: 700,
                    letterSpacing: { xs: 1, sm: 2 },
                    textAlign: "center",
                    textShadow: "2px 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                   Castco E-forms <br></br> 佳力高網上表格
                </Typography>
                <Typography
                  variant="subtitle1"
                  sx={{
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    mt: { xs: 1, sm: 2 },
                    fontWeight: 300,
                    opacity: 0.9,
                    textAlign: "center",
                    textShadow: "1px 1px 2px rgba(0,0,0,0.1)",
                  }}
                >
                    Castco Employee Login Portal
                </Typography>
              </Box>
            </Fade>
          </Grid>
  
          {/* Login Form Section */}
          <Grid
            item
            xs={12}
            lg={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: { xs: 3, sm: 4, md: 5, lg: 6 },
              backgroundColor: theme.palette.background.paper,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: { xs: "100%", sm: 400 },
                borderRadius: 2,
                padding: { xs: 3, sm: 4 },
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  fontSize: { xs: "1.25rem", sm: "1.5rem" },
                  fontWeight: 600,
                  color: theme.palette.info.main,
                  textAlign: "center",
                  mb: { xs: 2, sm: 3 },
                }}
              >
                Sign In
              </Typography>
              <form noValidate>
              <TextField
                autoComplete="email"
                label="Email"
                type="email"
                value={email}
                InputLabelProps={{ shrink: true }}  
                onChange={(e) => setEmail(e.target.value)}
                onKeyUp={EnterKeyOnClick}
                fullWidth
                variant="outlined"
                error={!!error}
                disabled={isLoading}
                sx={{
                  mb: { xs: 2, sm: 3 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.info.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.info.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.info.main,
                    "&.Mui-focused": { color: theme.palette.info.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
  
              <TextField
                autoComplete="current-password"
                label="Password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onKeyUp={EnterKeyOnClick}
                fullWidth
                variant="outlined"
                error={!!error}
                disabled={isLoading}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                InputLabelProps={{ shrink: true }}  
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                        sx={{  color: isHovered ? theme.palette.info.main : ""}}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  mb: { xs: 3, sm: 4 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: { xs: "8px", sm: "12px" },
                    transition: "all 0.3s ease",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.info.main,
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: theme.palette.info.main,
                      borderWidth: 2,
                    },
                  },
                  "& .MuiInputLabel-root": {
                    lineHeight: '1rem',
                    //color: theme.palette.info.main,
                    "&.Mui-focused": { color: theme.palette.info.main },
                  },
                  "& input": {
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    padding: { xs: "10px 12px", sm: "12px 14px" },
                  },
                }}
              />
              <Button
                variant="contained"
                onClick={handleLoginOnclick}
                disabled={isLoading}
                fullWidth
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    <LoginIcon />
                  )
                }
                sx={{
                  padding: { xs: "10px", sm: "12px" },
                  borderRadius: { xs: "20px", sm: "25px" },
                  background: `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.info.light} 100%)`,
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  transition: "all 0.3s ease",
                  "&:hover": {
                    background: `linear-gradient(135deg, ${theme.palette.info.dark} 0%, ${theme.palette.info.main} 100%)`,
                    transform: "translateY(-2px)",
                    boxShadow: theme.shadows[4],
                  },
                  "&:focus": {
                    outline: `2px solid ${alpha(
                      theme.palette.info.main,
                      0.5
                    )}`,
                    outlineOffset: "2px",
                  },
                  "&:disabled": {
                    background: theme.palette.action.disabledBackground,
                    color: theme.palette.action.disabled,
                  },
                }}
              >
                {isLoading ? "Signing in..." : "Sign In"}
              </Button>
              </form>
            </Box>
          </Grid>
        </Grid>
  
        <Snackbar
          open={!!error}
          autoHideDuration={6000}
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={() => setError(null)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {error}
          </Alert>
        </Snackbar>
      </Box>






      

    );
  };
  
  export default CastcoLoginPage;
  